import React, { useEffect, useState } from 'react';
import PrivateLayout from '../../../layouts/PrivateLayout/PrivateLayout';
import { Button, Datepicker, Dropdown, Spinner, TextInput } from 'flowbite-react';
import filterIcon from '../../../assets/filterIcon.png';
import { FaArrowDown, FaArrowUp, FaEllipsisH, FaSearch, FaSort } from 'react-icons/fa';
import CustomInput from '../../../components/CustomInputs/CustomInput';
import SearchIcon from '../../../assets/Search Key.png';
import downloadIcon from '../../../assets/document-download.png';
import CustomTable from '../../../components/Table/CustomTable';
import client from '../../../api/client';
import { ColumnTransactions, TransactionsData } from '../../../types/TablesTypes/Transactions';
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate';
import StatusView from '../../../components/StatusView/StatusView';
import showToast from '../../../components/CustomToast/toastHelper';
import moment, { Moment } from 'moment';
import { numberWithCommas } from '../../../utils/formatNumber';
import { useCurrency } from '../../../contexts/CurrencyContext';
import CustomModal from '../../../components/Modal/CustomModal';
import TransactionDetails from './TransactionDetails/TransactionDetails';
import RefundCustomer from './RefundCustomer/RefundCustomer';

const Transactions = () => {
    const [transactions, setTransactions] = useState<any>();
    const { currency } = useCurrency();
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        paymentreference: "",
        orderreference: ""
    });
    

    const [tableRow, setTableRow] = useState<any[]>();
    const [bearer, setBearer] = useState<boolean>(false);
    const [openDetailsModal, setOpenDetailsModal] = useState<boolean>(false)
    const [openRefundModal, setOpenRefundModal] = useState<boolean>(false)
    const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [isExport, setIsExport] = useState<boolean>(false)
    const [isExportReady, setIsExportReady] = useState<boolean>(false); 
    const [isExportLoading, setIsExportLoading] = useState<boolean>(false);


    const handleFilterChange = (filterName: string, value: string) => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    }

    const clickExport = async () => {
        setIsExport(true);
        setIsExportLoading(true)
        await fetchTransactions(true); 
    
        if (transactions && transactions.items?.length > 0) {
            setIsExportReady(true); 
        }
    
        setIsExportLoading(false); 
    };
    
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await fetchTransactions();
            setLoading(false)
        };
        fetchData();
    }, [filters, bearer, currency]);
    const fetchTransactions = async (isExport:boolean = false) => {
        try {
            const apiUrl = '/subsidiary/dashboard/fetch/orders';
            
            const params = new URLSearchParams(filters).toString();
            const response = await client.get(`${apiUrl}?${params}&currency=${currency}&IsExport=${isExport}`);

            setTransactions(response.data.data);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };
    useEffect(() => { 
        setFilters((prevFilters) => ({
            ...prevFilters,
            currency: currency,
        }));
    }, [currency]);
    const dataTransactions = () => {
        const tempArr: TransactionsData[] = [];

        transactions?.items
            ?.slice(0)
            .forEach((transaction: any, index: number) => {
                tempArr.push({
                    date: (moment.utc(transaction?.dateCreated).local() as Moment).format("DD-MMM-YYYY hh:mm:ss a"),
                    email: transaction?.customerEmail,
                    amount: `${transaction.currency} ${numberWithCommas(transaction?.amountFormatted)}`,
                    settlementAmount: `${transaction.currency} ${numberWithCommas(
                        transaction?.settlementAmount
                    )}`,
                    payment: transaction?.paymentTypeName,
                    reference: transaction?.orderReference,
                    status: (
                        <StatusView
                            status={transaction?.orderStatus}
                            green="Successful"
                            red="Awaiting-Confirmation"
                            orange="Initiated"
                        />
                    ),
                    action: (
                        <Dropdown label={
                            <FaEllipsisH />
                        } inline arrowIcon={false} placement='right-start'>
                            <Dropdown.Item onClick={() => handleOpenDetailsModal(transaction)}>View Details</Dropdown.Item>
                            <Dropdown.Item onClick={() => handleOpenRefundModal(transaction)}>Refund</Dropdown.Item>
                        </Dropdown>
                    ),
                });
            });
        return tempArr;
    };

    useEffect(() => {
        const fetchData = async () => {
            setTableRow(dataTransactions());
        }
        fetchData()

    }, [transactions?.items]);

    const handleOpenDetailsModal = (transaction: any) => {
        setSelectedTransaction(transaction);
        setOpenDetailsModal(true);
    };

    const handleOpenRefundModal = (transaction: any) => {
        setSelectedTransaction(transaction);
        setOpenRefundModal(true);
    };



    return (
        <>
            <DashboardPagesTemplate
                title='Transactions'
                dataToExport={isExportReady ? transactions?.items : []}
                onFilterChange={setFilters}
                apiUrl=''
                data={tableRow ? tableRow : []}
                filters={filters}
                exportButtonExists={true}
                dropdownItems={["All", "Initiated", "Awaiting-Confirmation", "Pending", "Successful", "Reversed", "Failed", "Processing"]}
                buttonLabel='null'
                buttonIcon={<img src={downloadIcon} />}
                headings={ColumnTransactions}
                showSearch={true}
                ctaButtonExists={false}
                emptyMessage={`You have not made any ${currency} transactions`}
                statusKey='status' 
                loading={loading}
                clickExportButton={clickExport}
                exportButtonLoading={isExportLoading}
                exportButtonClicked={isExport}
                />

            <CustomModal
                children={
                    openDetailsModal ? (
                        <TransactionDetails transaction={selectedTransaction} />
                    ) : openRefundModal ? (
                        <RefundCustomer transaction={selectedTransaction} close={()=>setOpenRefundModal(false)}/>
                    ) : null
                }
                dismissible={true}
                icon=''
                show={openDetailsModal || openRefundModal}
                size='lg'
                onClose={() => {
                    setOpenDetailsModal(false);
                    setOpenRefundModal(false);
                }}
            />
        </>
    )
}

export default Transactions;
